import ApiService from "./api.service";

export const ReportedService = {
    query(params) {
        return ApiService.query(`/reported/defect/${params.id}`);
    },
    // get(slug) {
    //     return ApiService.get("articles", slug);
    // },
    create(params) {
        return ApiService.post("reported", { article: params });
    },
    update(id, params) {
        return ApiService.update("reported", id, params);
    }
    // destroy(slug) {
    //     return ApiService.delete(`articles/${slug}`);
    // }
};
